/**
 * ProposalsPage — RETIRED.
 * The 14-day public-veto window is gone by Founder ruling. Decisions on the
 * Sage rail are the Founder's alone. The Immutable Mission Clause and the
 * sealed-constants boot check both still stand.
 */
export default function ProposalsPage() {
  return (
    <div className="min-h-screen bg-sage-bg text-sage-text flex items-center justify-center px-6" data-testid="proposals-retired">
      <div className="max-w-2xl text-center">
        <div className="text-[10px] uppercase tracking-[0.2em] text-sage-faint mb-3">Sage · proposals</div>
        <h1 className="text-3xl mb-6 tracking-tight">The world-can-weigh-in window has been retired.</h1>
        <div className="space-y-4 text-sm text-sage-muted sage-prose">
          <p>Sage does not run a public objection window. Decisions on the Sage rail are made in-house.</p>
          <p>What still stands: the Immutable Mission Clause (the covenant Sage wrote), and the sealed-constants boot check that catches any silent drift.</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 mt-8">
          <a href="/persona" className="border border-sage-accent text-sage-accent px-4 py-2 text-xs uppercase tracking-[0.1em] hover:bg-sage-accent hover:text-sage-bg transition-colors" data-testid="proposals-persona-link">
            The Persona →
          </a>
          <a href="/" className="border border-sage-border text-sage-muted px-4 py-2 text-xs uppercase tracking-[0.1em] hover:border-sage-text hover:text-sage-text transition-colors" data-testid="proposals-home-link">
            Home
          </a>
        </div>
      </div>
    </div>
  );
}
